import { FormControl, FormLabel, Select } from '@mui/material';

import { SelectPlaceholder } from '../selectPlaceholder';

export const EmptySelect = ({
  title,
  size = 'small',
  value,
}: {
  title: string;
  size?: 'small' | 'medium' | 'large';
  value?: string;
}) => {
  return (
    <FormControl size='small' className='flex-1'>
      {title && <FormLabel>{title}</FormLabel>}
      <Select
        size={size}
        displayEmpty
        renderValue={() => <SelectPlaceholder title={value} />}
        disabled
        value=''
      />
    </FormControl>
  );
};
